<p-panel header="Filters" [toggleable]="true" [collapsed]="true">
    <ng-template pTemplate="headericons" let-context>
        <i *ngIf="context" class="pi pi-filter"></i>
        <i *ngIf="!context" class="pi pi-times"></i>
    </ng-template>

    <div class="flex w-full flex-column gap-2">
        <div class="flex flex-column gap-2 w-6">
            <div class="flex flex-row gap-2 w-full">
                <div class="flex justify-content-end align-items-center w-3">
                    Filter Statuses
                </div>
                <div class="flex w-9">
                    <p-multiSelect 
                        *ngIf="filter" 
                        [options]="(statuses$ | async) ?? []" 
                        [(ngModel)]="filter.statuses"
                        optionLabel="description" 
                        optionValue="id" 
                        placeholder="Select Statuses"
                        [style]="{'width':'100%'}" 
                        class="flex flex-auto w-full" 
                        (onChange)="filterDirty=true" />
                </div>
            </div>
        </div>
        <div class="flex flex-column gap-2 w-6">
            <div class="flex flex-row gap-2 w-full">
                <div class="flex justify-content-end align-items-center w-3">
                    Search
                </div>
                <div class="flex w-9">
                    <input 
                        *ngIf="filter" 
                        type="text" 
                        pInputText
                        placeholder="Ex. Jane Doe, Left Wrist, ClaimNumber123WC-01, etc." 
                        class="flex flex-auto w-full"
                        [(ngModel)]="filter.searchTerm" 
                        (ngModelChange)="filterDirty=true" />
                </div>
            </div>
        </div>
        <div class="flex flex-row w-full justify-content-center">
            <p-buttonGroup>
                <p-button label="Filter" icon="pi pi-check" (onClick)="reFilter()" [disabled]="!filterDirty"></p-button>
                <p-button label="Cancel" icon="pi pi-times" severity="danger" (onClick)="resetFilter()"></p-button>
            </p-buttonGroup>
        </div>
    </div>


</p-panel>
<p-tabView>
    <p-tabPanel *ngFor="let section of searchResults$ | async | keyvalue" header="{{ section.key }}" slot="width:50rem;">
        <div class="justify-content-between align-items-center mb-3">
            <h3>Related Results for {{ section.key }}</h3>
            <button 
                pButton 
                type="button" 
                (click)="sortByDate()"
                [label]="sortOrder === 1 ? 'Oldest First' : 'Newest First'"
                [icon]="sortOrder === 1 ? 'pi pi-sort-amount-up' : 'pi pi-sort-amount-down'">
            </button>
        </div>
            <p-table 
                *ngIf="section.value" 
                [value]="section.value" 
                [rowHover]="true"
                [scrollable]="true"
                scrollHeight="flex">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 3.75rem;">Id</th>
                        <th style="width: 3.75rem;">Created</th>
                        <th style="width: 3.75rem;">Status</th>
                        <th style="width: 3.75rem;">Injured Worker</th>
                        <th style="width: 3.75rem;">Claim Number</th>
                        <th style="width: 3.75rem;">Body Part</th>
                        <th style="width: 3.75rem;">Adjuster</th>
                        <th style="width: 3.75rem;">Carrier</th>
                        <th style="width: 3.75rem;">Procedure Type</th>
                        <th style="width: 3.75rem;">Assigned To</th>
                        <th style="width:9rem"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-encounter let-index="rowIndex">
                    <tr (click)="encounterSelected(encounter)">
                        <td>{{ encounter.id }}</td>
                        <td>{{ encounter.createDate | date : 'shortDate'}}</td>
                        <td><span [pTooltip]="encounter.closureReason"
                                [tooltipDisabled]="encounter.encounterStatus != 'Closed'">{{
                                encounter.encounterStatus }}</span></td>
                        <td>{{ encounter.party }} </td>
                        <td>{{ encounter.claimNumber}}</td>
                        <td>{{ encounter.bodyPart }}</td>
                        <td>{{ encounter.adjuster }}</td>
                        <td>{{ encounter.carrier }}</td>
                        <td>{{ encounter.procedureType }}</td>
                        <td>{{ encounter.assignedTo }}</td>
                        <td>
                            <div class="flex gap-2">
                                <p-button *ngIf="(currentUser$ | async) as me" 
                                [rounded]="true" 
                                icon="pi pi-ticket"
                                [text]="true" 
                                [raised]="true" 
                                pTooltip="Take Ownership"
                                (click)="assignEncounter(encounter.id, me )"></p-button>
                                <p-button [rounded]="true" icon="pi pi-user" [text]="true" [raised]="true"
                                    pTooltip="Assign To" (click)="assignToOverlay.toggle($event)"></p-button>
                                <p-button [rounded]="true" icon="pi pi-folder-open" [text]="true" [raised]="true"
                                    pTooltip="Open" (click)="openEncounter(encounter)"></p-button>
                                <!-- <p-button [rounded]="true" icon="pi pi-eye" [text]="true" [raised]="true" pTooltip="View" ></p-button> -->
                                <p-button icon="pi pi-times" [text]="true" pTooltip="Close"
                                    (onClick)="closeOverlay.toggle($event)" severity="danger"></p-button>
                                <p-overlayPanel #assignToOverlay>
                                    <p-dropdown 
                                        [options]="(activeUsers$ | async) ?? []" 
                                        optionLabel="fullName"
                                        placeholder="Select a User"
                                        (onChange)="assignEncounter(encounter.id, $event.value)" />
                                </p-overlayPanel>
                                <p-overlayPanel #closeOverlay>
                                    <p-dropdown 
                                        [options]="(closureReasons$ | async) ?? []"
                                        optionLabel="description"
                                        placeholder="Closure Reason"
                                        (onChange)="closeEncounter(encounter, $event.value)">
                                    </p-dropdown>
                                </p-overlayPanel>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
    </p-tabPanel>
</p-tabView>